/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Context_PromptingInputs */



/**
* | output |
* | --- |
* | "Context & Prompting" |
*
* @param {Ad_Section_Context_PromptingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_context_prompting = /** @type {((inputs?: Ad_Section_Context_PromptingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Context_PromptingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contexte et instructions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontext und Anweisungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contesto e istruzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контекст и инструкции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contexto e instrucciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上下文与提示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテキストと指示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संदर्भ और निर्देश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contexto e instruções")
	return /** @type {LocalizedString} */ ("Context & Prompting")
});